module.exports = __webpack_public_path__ + "img/1-2.4吴晓波（财经作家）.67bd013c.jpg";